import React, { useState, useEffect } from "react";
import { Col, FormGroup, Pagination, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import CollectionSubMenu from "./collectionSubMenu";
import { getNewCollectionByEmailStart } from "store/actions";
import { Oval } from 'react-loader-spinner'
export default function TableData(props) {
    const getEmail = useSelector((state) => state?.Login.user.email);
    const dispatch = useDispatch();
    const location = useLocation();
    const [pageName, setpageName] = useState(props.data);
    const [email, setEmail] = useState({ email: getEmail })
    const [search, setSearch] = useState('')
    const [nftdata, setNftdata] = useState([])
    const pagepath = location.pathname.split('/')
    const activepath = pagepath.filter((res) => res === 'soldbyartist')
    const { loading } = useSelector((state) => state?.collections);
    const pagesoldbyartist = activepath[0]
    const navigate = useNavigate();
    const [collectionByEmail, setCollectionByEmail] = useState([])
    useEffect(() => {
        const callback = (res) => {
            if (res.status === "success") {
                console.log("312412341234", res)
                setCollectionByEmail(res.data)
            }
        }
        dispatch(getNewCollectionByEmailStart(email, callback));
    }, [email]);

    const Redirect = () => {
        const GetAddress = localStorage.getItem("walletAddress");
        if (pageName === 'collection') {
            navigate("../collection/createcollection");
        } else {
            if (GetAddress) {
                navigate("../nft/createnft");
            } else {
                navigate("/metamask-sign");
            }
        }
    };
    // const [dataLength, setDataLength] = useState([])
    // const [dataAfterPagination, setDataAfterPagination] = useState([])
    // var [value, setValue] = useState(10)
    // var [sNoValue, setSNovalue] = useState(0)

    // useEffect(() => {
    //     let x = 0;
    //     if (collectionByEmail?.length < 9) {
    //         x = 1;
    //     } else {
    //         x = Math.ceil(collectionByEmail.length / 10);
    //     }
    //     const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
    //     setDataLength(newLengthArray);
    // }, [collectionByEmail]);
    // useEffect(() => {
    //     if (collectionByEmail?.length < 9) {
    //         setDataLength([1]);
    //     } else {
    //         const x = Math.ceil(collectionByEmail.length / 10);
    //         const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
    //         setDataLength(newLengthArray);
    //     }
    // }, [collectionByEmail]);
    // useEffect(() => {
    //     let arr = [];
    //     setSNovalue(value - 10);
    //     for (let i = value - 10; i < value; i++) {
    //         if (collectionByEmail[i]) {
    //             arr.push(collectionByEmail[i]);
    //         }
    //     }
    //     setDataAfterPagination(arr);
    // }, [value, collectionByEmail, dataLength]);
    // const handlePagination = (val) => {
    //     let valu = 0;
    //     if (val === "<<") {
    //         valu = 10;
    //     } else if (val === "<") {
    //         valu = Math.max(0, value - 10);
    //     } else if (val === ">" && sNoValue / 10 < value) {
    //         valu = (parseInt(value / 10) + 1) * 10;
    //     } else if (val === ">>" && value < collectionByEmail.length) {
    //         valu = Math.ceil(collectionByEmail.length / 10) * 10;
    //     } else {
    //         valu = parseInt(val) * 10;
    //     }
    //     setValue(valu);
    // };
    // useEffect(() => {
    //     console.log("Search Triggered:", search);

    //     setDataAfterPagination(
    //         collectionByEmail?.filter((item) =>
    //             search.toLowerCase() === '' ? true : item.name.toLowerCase().includes(search.toLowerCase())
    //         )
    //     );
    //     if(search===""){
    //         setDataAfterPagination(collectionByEmail)
    //     }
        
    // }, [search]);
    const [dataLength, setDataLength] = useState([]);
    const [dataAfterPagination, setDataAfterPagination] = useState([]);
    const [value, setValue] = useState(10);
    let [sNoValue, setSNovalue] = useState(0);
    const [filteredData, setFilteredData] = useState([]); // Stores search results
    
    // Update pagination length when data changes
    useEffect(() => {
        const length = collectionByEmail?.length || 0;
        const pages = Math.ceil(length / 10) || 1;
        setDataLength(Array.from({ length: pages }, (_, index) => index + 1));
        setFilteredData(collectionByEmail); // Reset filtered data
    }, [collectionByEmail]);
    
    // Update pagination when value or filtered data changes
    useEffect(() => {
        let startIdx = value - 10;
        let endIdx = value;
        setDataAfterPagination(filteredData.slice(startIdx, endIdx));
        setSNovalue(startIdx + 1); // Maintain correct serial numbers
    }, [value, filteredData]);
    
    // Handle search updates
    useEffect(() => {
        const searchResults = collectionByEmail?.filter((item) =>
            search.toLowerCase() === "" ? true : item.name.toLowerCase().includes(search.toLowerCase())
        ) || [];
    
        setFilteredData(searchResults);
        setValue(10); // Reset pagination to the first page
        setSNovalue(1); // Reset serial number when searching
    }, [search, collectionByEmail]);
    
    // Handle pagination navigation
    const handlePagination = (val) => {
        let newValue = value;
        
        if (val === "<<") newValue = 10;
        else if (val === "<") newValue = Math.max(10, value - 10);
        else if (val === ">" && value < filteredData.length) newValue = value + 10;
        else if (val === ">>") newValue = Math.min(Math.ceil(filteredData.length / 10) * 10, filteredData.length);
        else newValue = parseInt(val) * 10;
    
        setValue(newValue);
        setSNovalue(newValue - 9); // Update serial number correctly
    };
    


    return (
        <>
            {loading &&
                <div className='loaderBoxMiane'>
                    <Oval
                        height={80}
                        width={80}
                        color="#6C63FF"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#6C63FF"
                        strokeWidth={2}
                        strokeWidthSecondary={2}

                    />
                </div>
            }
            <Row>
                <Col lg={12}>
                    <div className="TabsBox">
                        {pageName === 'nft' ? (<CollectionSubMenu data={pageName} />) : ('')}


                        {(collectionByEmail.length > 0 || nftdata.length > 0 ) ? (

                            <div className="TabsData mt-4">
                                <Row className="justify-content-between">
                                    <Col lg={6}>
                                        <FormGroup className="position-relative">
                                            <Input onChange={(e) => setSearch(e.target.value)} className="form-control searchInput" placeholder="Search" />
                                            <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0"><i className="fa-light fa-magnifying-glass"></i></button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        {(pageName === 'collection' ) ? (<div className="table-responsive tableNft">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <td className="text-center">No.</td>
                                                        <td className="text-center">Image</td>
                                                        <td>Collection Name</td>
                                                        <td className="text-center">Available Artworks</td>
                                                        <td className="text-center">Sold Artworks</td>
                                                        <td className="text-center">Minted Artworks</td>
                                                        <td className="text-center"> Status</td>
                                                        <td className="text-center">Action</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataAfterPagination?.map((item, index) =>
                                                        <tr>
                                                            <td className="text-center">{sNoValue+index}</td>
                                                            <td className="text-center"><img className="nftimge mx-auto" alt="" src={item.image?.link} /></td>
                                                            <td >{item.name}</td>
                                                            <td className="text-center">{item.totalNfts}</td>
                                                            <td className="text-center">{item.totalNftSold}</td>
                                                            <td className="text-center">{item.totalMinted}</td>
                                                            <td className="text-center">
                                                                <div className={"statusbtt" + (item.status === true ? ' onsale' : ' pendingstatus')}>
                                                                    {item.status === true ? "On Sale" : "Off Sale"}
                                                                </div></td>
                                                            <td className="text-center">
                                                                <Link to={`../collection/createcollection/${item._id}`}><button className="btn border-0" ><i className="fa-regular fa-pen-to-square"></i></button></Link>
                                                                <Link to={`../collection/viewcollection/${item._id}`}><button className="btn border-0" ><i className="fa-regular fa-eye"></i></button></Link>

                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>) : (
                                            <div className="table-responsive tableNft">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <td className="text-center">No.</td>
                                                            <td>Collection Name</td>
                                                            <td className="text-center">Total Owners</td>
                                                            <td className="text-center">Total Copies</td>
                                                            <td className="text-center">Total Minted</td>
                                                            <td className="text-center">Current Sale Ord.</td>
                                                            <td className="text-center">Status</td>
                                                            <td className="text-center">Action</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        <tr>
                                                            <td className="text-center">1</td>
                                                            <td><img className="nftimge" alt="" src={"../../images/png/artist4.png"} /> Artwork Name</td>
                                                            <td className="text-center">1</td>
                                                            <td className="text-center">10</td>
                                                            <td className="text-center">1</td>
                                                            <td className="text-center">None</td>
                                                            <td className="text-center">
                                                                {pagesoldbyartist === 'soldbyartist' ? (<button className="statusbtt pendingstatus">Pending</button>) : (
                                                                    <button className="statusbtt onsale">On Sale</button>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button>
                                                                <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center">1</td>
                                                            <td><img className="nftimge" alt="" src={"../../images/png/artist4.png"} /> Artwork Name</td>
                                                            <td className="text-center">1</td>
                                                            <td className="text-center">10</td>
                                                            <td className="text-center">1</td>
                                                            <td className="text-center">None</td>
                                                            <td className="text-center">
                                                                {pagesoldbyartist === 'soldbyartist' ? (<button className="statusbtt verifiesstatus">Verified</button>) : (
                                                                    <button className="statusbtt onsale">On Sale</button>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button>
                                                                <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center">1</td>
                                                            <td><img className="nftimge" alt="" src={"../../images/png/artist4.png"} /> Artwork Name</td>
                                                            <td className="text-center">1</td>
                                                            <td className="text-center">10</td>
                                                            <td className="text-center">1</td>
                                                            <td className="text-center">None</td>
                                                            <td className="text-center">
                                                                {(pagesoldbyartist === 'soldbyartist') ? (<button className="statusbtt rejectedstatus">Rejected</button>) : (
                                                                    <button className="statusbtt onsale">On Sale</button>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button>
                                                                <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                    </Col>
                                    {dataAfterPagination.length > 0 ? 
                                    <Col lg={12} className="text-end">
                                        <Pagination className="paginationNew" aria-label="Page  navigation example">
                                            {value > 10 &&
                                                <div className="d-flex align-items-center gap-2">
                                                    <PaginationItem >
                                                        <PaginationLink
                                                            first
                                                            href="#"
                                                            onClick={() => handlePagination("<<")}
                                                        />
                                                    </PaginationItem>
                                                    <PaginationItem >
                                                        <PaginationLink
                                                            href="#"
                                                            previous
                                                            onClick={() => handlePagination("<")}
                                                        />
                                                    </PaginationItem>
                                                </div>
                                            }
                                            {dataLength && dataLength.map((item) =>
                                                <PaginationItem className={parseInt(item) === (value / 10) ? "active" : ""}>
                                                    <PaginationLink href="#" onClick={() => handlePagination(item)}>
                                                        {item}
                                                    </PaginationLink>
                                                </PaginationItem>
                                            )}
                                            {value < collectionByEmail.length &&
                                                <div>
                                                    <PaginationItem>
                                                        <PaginationLink
                                                            href="#"
                                                            next
                                                            onClick={() => handlePagination(">")}
                                                        />
                                                    </PaginationItem>
                                                    <PaginationItem>
                                                        <PaginationLink
                                                            href="#"
                                                            last
                                                            onClick={() => handlePagination(">>")}
                                                        />
                                                    </PaginationItem>
                                                </div>
                                            }
                                        </Pagination>
                                    </Col> :
                                          <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                          <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                                          {pageName === 'collection' && <h3>No Collelction</h3>}
                                          {pageName !== 'collection' && <button onClick={Redirect} className="btn btn-primary mt-4">List on Marketplace</button>}
                                      </div>
}
                                </Row>
                            </div>
                        ) : (
                            <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                <img src={"../../images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                                {pageName === 'collection' && <h3>No Collelction</h3>}
                                {pageName !== 'collection' && <button onClick={Redirect} className="btn btn-primary mt-4">List on Marketplace</button>}
                            </div>
                        )}
                    </div>

                </Col>
            </Row>
            {loading ? (<Spinner animation="border" size="sm" role="status"></Spinner>) : ('')}
        </>
    );
}

